import { createContext, useEffect } from 'react';

const NavigationContext = createContext();

//this name was contrived by me.
//Also I could have written it this way
//const NavigationProvider = () => {
//but here is the alternative syntax ...
function NavigationProvider(props) {
    //reminder window.location is whatever is present in the URL address bar
    //const [currentPath, setCurrentPath] = useState(window.location.pathname);
    //everything here deals with the user clicking forward and back arrows.
    //The main purpose is to cause a re-render when the user goes back and forth.
    //This NavigationContext.Provider wraps the entire application. See src > index.js
    //The following comment is obsolete. Not using my custom Route component in this version
    //BECAUSE you want the Route component to rerender so that Route component 
    // re-evaluates the currentPath (from context here), else the Route component
    //  can not express its underlying component!
    useEffect(() => {
        //whenever the user navigates around by using the back and forth buttons
        //this handler is going to be called because we need to have a currentPath value
        //initialized and used in the app per each re-render
        const handler = () => {
            //alert("pop state");
            navBar(window.location.pathname);
        }
        //popstate is the event that is fired when navigating the URL with forward and backward buttons.
        //popstate is not invoked by window.history.pushState({}, '', to); It is only fired by  forward and backward button clicks.
        //
        window.addEventListener('popstate', handler);
        //cleanup function called if ever the component is removed (it never is in this scenario! So this is overkill)
        return () => {
            alert("cleanup called");
            window.removeEventListener('popstate', handler);
        }
    });

    const navBar = (path) => {
        let portfolioLink = document.getElementById('portfolio-link');
        let imagesLink = document.getElementById('images-link');
        let contactLink = document.getElementById('Contact-link');
        let aboutLink = document.getElementById('about-link');
        let slideShowlink = document.getElementById('slideshow-link');
        //Whenever we arrive here, one of the 5 links will already be in a dimmed out opacity from the prior time, all the other links are showing at full opacity.
        //We don't know which of the five links is dimmed from prior, so we assign showing to all of them, and whichever link is the prior dimmed link 
        //will display the full opacity fade-in effect.
        //All the other links that are already at full opacity when they are assigned 'showing', will not appear to do anything since they are already showing.
        //Next, since they are now all at full opacity, and we want to decide which one to fade out. That is what navigationFilter(path) will do.
        portfolioLink.className = 'photography-nav-spacing showing'; 
        imagesLink.className = 'photography-nav-spacing showing';
        contactLink.className = 'photography-nav-spacing showing';
        aboutLink.className = 'photography-nav-spacing showing';
        slideShowlink.className = 'photography-nav-spacing showing';  
        navigationFilter(path);
    }

    const navigationFilter = (path) => {
        switch (path) {
            case "/":
                setStyle('slideshow-link');
                break;
            case "/Portfolio":
                setStyle('portfolio-link');
                break;
            case "/Images":
                setStyle('images-link');
                break;
            case "/About":
                setStyle('about-link');
                break;
            case "/Contact":
                setStyle('Contact-link');
                break;
            default: {
                alert(path);
            }
        }
    }
    //the only purpose for this context is to dim the link
    const setStyle = (link) => {
        let linkelement = document.getElementById(link);
        linkelement.className = 'photography-nav-spacing dimNavLink';   
    };

    //reminder: value is what will be shared with the rest of the application
    //He says that this "NavigationContext.Provider" was automatically given to us by our context
    //Now, we want to wrap the component(s) with NavigationContext to make values 
    //available to lower components whatever values are in context.
    return <NavigationContext.Provider value={{ navBar }}>
        {props.children}
    </NavigationContext.Provider>
}
//this way makes it a Named import
export { NavigationProvider };
export default NavigationContext;